import React from 'react';
import { useFormikContext } from "formik";
import AddressModal from "./AddressModal";
import TwoColumnDiv from "./TwoColumnDiv";
import TextInput from "../input/TextInput";
import StateDropdown from "../input/StateDropdown";
import { EmployeeFormValues } from "../common/EmployeeFormValues";
import { Party } from "../enums/Party";
import { EmployerFormValues } from "../common/EmployerFormValues";
import ZipCodeInput from "../input/ZipCodeInput";
import { PfmlEmployeeFormValues } from "../pfml/PfmlEmployeeFormValues";

var _ = require('lodash');

const EmployeeAddress = () => {
    const { values } = useFormikContext<PfmlEmployeeFormValues>()

    return <>
            <AddressModal streetAddressField="streetAddress" cityField="city" stateField="state" zipCodeField="zipCode"/>
            <TextInput id="street-address" label={buildLabel(values, 'Street address')} required={true}/>
            <TwoColumnDiv leftContent={<TextInput id="city" label={buildLabel(values, 'City')} required={true}/>}
                          rightContent={<TwoColumnDiv
                              leftContent={<StateDropdown id="state" label={buildLabel(values, 'State')} required={true}/>}
                              rightContent={<ZipCodeInput id="zip-code" label={buildLabel(values, 'ZIP', false)} required={true}/>}>
                          </TwoColumnDiv>}/>
        </>
};

function buildLabel(values: EmployeeFormValues | EmployerFormValues, baseLabel: string, lowercase = true) {
    let label = baseLabel;
    if(values.party === Party.EMPLOYER) {
        label = "Employee's " + (lowercase ? _.lowerCase(label) : label);
    }
    return label;
}

export default EmployeeAddress;